import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import BasicButton from '../Common/Button/BasicButton';
import { colors } from '@/const/colors';

export interface CarErrorProps {
  img: string;
  title?: string;
  subTitle?: string;
  description?: string;
}

const CarError = ({ img, title, subTitle, description }: CarErrorProps) => {
  const navigate = useNavigate();

  const handleClickHome = () => {
    navigate('/products');
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center w-full h-full mb-10">
        <span className="mb-4">
          <img src={img} alt="car error" className="w-[185px] h-[131px]" />
        </span>
        {title && (
          <div className="flex flex-col items-center justify-center gap-1">
            <span
              className="font-semibold text-[24px] text-gray-8 text-center"
              dangerouslySetInnerHTML={{ __html: title }}
            ></span>
            {subTitle && (
              <span
                className="text-gray-7 text-[18px] leading-[25px] break-keep text-center"
                dangerouslySetInnerHTML={{ __html: subTitle }}
              ></span>
            )}
          </div>
        )}
        {description && (
          <span
            className="mt-16 mb-6 text-gray-7 text-[18px] leading-[25px] break-keep text-center"
            dangerouslySetInnerHTML={{ __html: description }}
          ></span>
        )}
        <div className="w-full px-4">
          <BasicButton
            name="더 많은 차량 보기"
            bgColor={colors.primary[10]}
            borderColor={colors.primary[10]}
            textColor={colors.gray[0]}
            fontSize={16}
            height={48}
            fontWeight="bold"
            onClick={handleClickHome}
          />
        </div>
      </div>
    </>
  );
};

export default CarError;
